import React from 'react';

import { useApp } from '../../../store/AppContext';
import { fmtDate } from '../../../utils/format';
import { clientColor } from '../../../utils/phases';
import PlanningBar from '../shared/PlanningBar';
import AbsenceBar from './AbsenceBar';

/* Barres d'affectations (couleur du client) et d'absences d'un membre. */
export default function MemberBars({ segs, dev }) {
  const { appState } = useApp();
  return segs.map((sg) => {
    if (sg.isAbs) return <AbsenceBar key={sg.affId} sg={sg} dev={dev} />;
    const hoverLines = [
      { label: sg.clientName, value: '', bold: true },
      ...(sg.brique
        ? [{ label: 'Brique', value: sg.brique }]
        : [{ label: '', value: 'Niveau client' }]),
      { label: 'Période', value: `${fmtDate(sg.realStart)} → ${fmtDate(sg.realEnd)}` },
      { label: 'Planifié', value: `${sg.totalH}h (${sg.h}h/jour)` },
    ];
    return (
      <PlanningBar
        key={sg.affId}
        sg={sg}
        match={{ devId: dev.id }}
        color={clientColor(appState.clients, sg.clientId)}
        label={sg.brique ? `${sg.clientName} · ${sg.brique}` : sg.clientName}
        hoverLines={hoverLines}
      />
    );
  });
}
